import { useState } from 'react';
import { FaBars, FaTimes, FaGithub, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-scroll';
import { personalGitHub, personalLinkedIn } from '../../constants/navigation';

const Menu = () => {
  return (
    <>
      <ul className="hidden md:flex">
        <li>
          <Link to="home" smooth={true} duration={500} className='hover:text-accent transition duration-300'>
            Home
          </Link>
        </li>
        <li>
          <Link to={'about'} smooth={true} duration={500} className='hover:text-accent transition duration-300'>
            About
          </Link>
        </li>
        <li>
          <Link to="skills" smooth={true} duration={500} className='hover:text-accent transition duration-300'>
            Skills
          </Link>
        </li>
        <li>
          <Link to="work" smooth={true} duration={500} className='hover:text-accent transition duration-300'>
            Projects
          </Link>
        </li>
        <li>
          <Link to="contact" smooth={true} duration={500} className='hover:text-accent transition duration-300'>
            Contact
          </Link>
        </li>
      </ul>
    </>
  );
};

const MobileMenu = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <>
      {/* Hamburger */}
      <div onClick={handleClick} className="md:hidden z-10">
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile menu */}
      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen bg-primary flex flex-col justify-center items-center'
        }
      >
        <li className="py-6 text-4xl">
          <Link onClick={handleClick} to="home" smooth={true} duration={500}>
            Home
          </Link>
        </li>
        <li className="py-6 text-4xl">
          {' '}
          <Link onClick={handleClick} to="about" smooth={true} duration={500}>
            About
          </Link>
        </li>
        <li className="py-6 text-4xl">
          {' '}
          <Link onClick={handleClick} to="skills" smooth={true} duration={500}>
            Skills
          </Link>
        </li>
        <li className="py-6 text-4xl">
          {' '}
          <Link onClick={handleClick} to="work" smooth={true} duration={500}>
            Projects
          </Link>
        </li>
        <li className="py-6 text-4xl">
          {' '}
          <Link onClick={handleClick} to="contact" smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>
    </>
  );
};

export const NavBar = () => {
  return (
    <div className="fixed w-full h-[80px] flex justify-between items-center px-4 bg-primary text-gray-300">
      <div className="flex flex-row ">
        <a href={personalLinkedIn} target="_blank" rel="noreferrer" className='hover:text-accent transition duration-300'>
          <FaLinkedin size={25} style={{ marginRight: '15px' }} />
        </a>
        <a href={personalGitHub} target="_blank" rel="noreferrer" className='hover:text-accent transition duration-300'>
          <FaGithub size={25} />
        </a>
      </div>

      <Menu />
      <MobileMenu />
    </div>
  );
};
